import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Products from "../../components/pages/Cart/Products/Products";
import GeneralSlider from "../../components/general/GeneralSlider/GeneralSlider";

const goodsArr = [
  { id: 0, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 1, img: "/img/main/temp/2.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 2, img: "/img/main/temp/3.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 3, img: "/img/main/temp/4.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 4, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
];

const CartPage: React.FC = () => {
  return (
    <Layout>
      <Products />
      <GeneralSlider title="Рекомендуем" subtitle="Посмотреть все товары" slides={goodsArr} />
      <Feedback />
    </Layout>
  );
};

export default CartPage;
